/* eslint-disable no-constant-condition */
import React from "react";
import FreeTrialImg from "../../assets/home/free-trial.svg";
import { useState } from "react";
import { FaCheckSquare } from "react-icons/fa";
import axios from "axios";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { useParams } from "react-router-dom";

const Index = () => {
  const [isLoading, setLoading] = useState(false);
  const [active, setActive] = useState("");
  const params = useParams();
  const { ref } = params;
  // console.log("ref", ref);
  const [active2, setActive2] = useState("");
  const [activeCoding, setActiveCoding] = useState("");
  const [age, setAge] = useState();
  const [day, setDay] = useState();
  // const [time, setTime] = useState();
  const [class1, setClass1] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [isError, setIsError] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  // console.log(class1);
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    console.log(e);
    // setActiveCoding("offline")

    const data = new FormData();
    if (ref) {
      data.append("referal_code", ref);
    }
    if (activeCoding !== "" || activeCoding) {
      data.append("kategori_trial", `${class1} - ${activeCoding}`);
    } else {
      data.append("kategori_trial", class1);
    }
    // data.append("kategori_trial", class1);
    data.append("nama_orang_tua", e.target.parent.value);
    data.append("nama_anak", e.target.child.value);
    data.append("umur_anak", age);
    data.append("no_wa", e.target.wa.value);
    data.append("hari", day);
    data.append("jam", e.target.time.value);
    data.append("email", e.target.email.value);
    axios
      .post("https://educourse.id/api/trialcourse/", data)
      .then((res) => {
        console.log(res);
        setSuccessMessage("Selamat pendaftaran Anda berhasil!");
        setIsError(false);
        // Simulasi loading selama 5 detik
        setTimeout(() => {
          // Lakukan logika pengiriman data atau tindakan lainnya di sini
          setLoading(false);
        }, 5000);
        openModal();
      })
      .catch((error) => {
        console.log(error);
        setErrorMessage(
          error.response?.data?.message ?? "Mohon melengkapi data diri Anda"
        );
        setIsError(true);
        openModal();
      });
  };

  const closeModal = () => {
    setIsOpen(false);
  };
  const openModal = () => {
    setIsOpen(true);
  };

  return (
    <>
      <section className='flex flex-col lg:flex-row  px-12 xl:px-24  gap-12 items-center justify-center lg:pt-20 lg:pb-20 pt-12 bg-gray-100'>
        <img src={FreeTrialImg} alt='FreeTrialImg' className='w-[510px] ' />
        <div className='flex flex-col gap-4 mb-12 lg:mb-0'>
          <div className='md:text-2xl text-2xl font-bold text-[#4CA7B1] font-sans text-center mb-5'>
            Form Registrasi Kelas Trial
          </div>
          <div className='w-full sm:w-[479px] h-auto rounded-[10px] p-2 bg-white shadow-md '>
            <form onSubmit={handleSubmit} className='flex flex-col gap-3'>
              <div className='flex flex-col'>
                <label className='mb-2 text-[#4CA7B1] text-sm'>Kelas</label>
                <div className='grid grid-cols-3 gap-1'>
                  <div
                    onClick={() => {
                      setActive("coding");
                      setAge(null);
                      // console.log(active);
                    }}
                    className={` rounded-[10px] border-2 border-solid border-turquoise-normal p-4 flex flex-col justify-center items-center cursor-pointer 
                  ${active === "coding" ? "bg-[#F7CE46]" : "bg-white"}`}>
                    <input
                      type='radio'
                      id='coding'
                      name='kelas'
                      // value="Coding STEAM"
                      className='opacity-0 absolute '
                      defaultChecked={active === "coding" ? true : false}
                    />
                    <label htmlFor='coding'>Coding STEM</label>
                  </div>
                  <div
                    onClick={() => {
                      setActive("robotic");
                      setAge(null);
                    }}
                    className={` rounded-[10px] border-2 border-solid border-turquoise-normal p-4 flex flex-col justify-center items-center cursor-pointer 
                  ${active === "robotic" ? "bg-[#F7CE46]" : "bg-white"}`}>
                    <input
                      type='radio'
                      id='robotic'
                      name='kelas'
                      // value="Robotic STEAM"
                      className='opacity-0 absolute'
                      defaultChecked={active === "robotic" ? true : false}
                      onChange={(e) => {
                        console.log(e);
                        if (e.target.checked) {
                          setClass1("Robotic");
                        } else {
                          setClass1("");
                        }
                      }}
                    />
                    <label htmlFor='robotic'>Robotic</label>
                  </div>
                  {/* <div
                    onClick={() => {
                      setActive("english");
                      setAge(null);
                    }}
                    className={`rounded-[10px] border-2 border-solid border-turquoise-normal p-4 flex flex-col justify-center items-center cursor-pointer 
                  ${active === "english" ? "bg-[#F7CE46]" : "bg-white"}`}>
                    <input
                      type='radio'
                      id='english'
                      name='kelas'
                      // value="English STEAM"
                      className='opacity-0 absolute'
                      defaultChecked={active === "english" ? true : false}
                      onChange={(e) => {
                        console.log(e);
                        if (e.target.checked) {
                          setClass1("English");
                        } else {
                          setClass1("");
                        }
                      }}
                    />
                    <label htmlFor='english'>English Languages</label>
                  </div> */}
                  {/* <div
                    onClick={() => {
                      setActive("korean");
                      setAge(null);
                    }}
                    className={` rounded-[10px] border-2 border-solid border-turquoise-normal p-4 flex flex-col justify-center items-center cursor-pointer 
                  ${active === "korean" ? "bg-[#F7CE46]" : "bg-white"}`}>
                    <input
                      type='radio'
                      id='korean'
                      name='kelas'
                      // value="Korean STEAM"
                      className=' opacity-0 absolute'
                      defaultChecked={active === "korean" ? true : false}
                      onChange={(e) => {
                        console.log(e);
                        if (e.target.checked) {
                          setClass1("Korea");
                        } else {
                          setClass1("");
                        }
                      }}
                    />
                    <label htmlFor='korean'>Korean Languages</label>
                  </div> */}
                  {/* <div
                    onClick={() => {
                      setActive("japan");
                      setAge(null);
                    }}
                    className={` rounded-[10px] border-2 border-solid border-turquoise-normal p-4 flex flex-col justify-center items-center cursor-pointer 
                  ${active === "japan" ? "bg-[#F7CE46]" : "bg-white"}`}>
                    <input
                      type='radio'
                      id='japan'
                      name='kelas'
                      // value="Japan STEAM"
                      className=' opacity-0 absolute'
                      defaultChecked={active === "japan" ? true : false}
                      onChange={(e) => {
                        console.log(e);
                        if (e.target.checked) {
                          setClass1("Jepang");
                        } else {
                          setClass1("");
                        }
                      }}
                    />
                    <label htmlFor='japan'>Japan Languages</label>
                  </div> */}
                  {/* <div
                    onClick={() => {
                      setActive("arab");
                      setAge(null);
                    }}
                    className={` rounded-[10px] border-2 border-solid border-turquoise-normal p-4 flex flex-col justify-center items-center cursor-pointer 
                  ${active === "arab" ? "bg-[#F7CE46]" : "bg-white"}`}>
                    <input
                      type='radio'
                      id='arab'
                      name='kelas'
                      // value="Arab STEAM"
                      className=' opacity-0 absolute'
                      defaultChecked={active === "arab" ? true : false}
                      onChange={(e) => {
                        console.log(e);
                        if (e.target.checked) {
                          setClass1("Arab");
                        } else {
                          setClass1("");
                        }
                      }}
                    />
                    <label htmlFor='arab'>Arab Languages</label>
                  </div> */}
                </div>
              </div>

              {active === "robotic" ? (
                <>
                  <div
                    className='flex items-center bg-blue-500 text-white text-sm font-bold px-4 py-3'
                    role='alert'>
                    <svg
                      className='fill-current w-4 h-4 mr-2'
                      xmlns='http://www.w3.org/2000/svg'
                      viewBox='0 0 20 20'>
                      <path d='M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z' />
                    </svg>
                    <p>
                      Kelas robotic dilakukan{" "}
                      <strong>
                        <i>Onsite</i>
                      </strong>{" "}
                      .
                    </p>
                  </div>
                  <div className='flex flex-col'>
                    <label className='mb-2 text-[#4CA7B1]'>
                      Umur Anak (tahun)
                    </label>
                    <input
                      type='number'
                      min='1'
                      defaultValue={age}
                      onChange={(e) => setAge(e.target.value)}
                      className='p-2 border border-gray-400 rounded-md bg-[#D9D9D9] border-0'
                      required
                    />
                    {age >= 1 ? (
                      <>
                        <div className='flex flex-col '>
                          <label className='mb-2 mt-4 text-[#4CA7B1] '>
                            Hari
                          </label>
                          <select
                            defaultValue={day}
                            onChange={(e) => {
                              setDay(e.target.value);
                            }}
                            className='p-2 border border-gray-400 rounded-md bg-[#D9D9D9] border-0'
                            required>
                            <option value=''>Pilih Hari</option>
                            <option value='Senin'>Senin</option>
                            <option value='Selasa'>Selasa</option>
                            <option value='Rabu'>Rabu</option>
                            <option value='Kamis'>Kamis</option>
                            <option value='Jumat'>Jumat</option>
                            <option value='Sabtu'>Sabtu</option>
                            {/* <option value='Minggu'>Minggu</option> */}
                          </select>
                          <label className='mb-2 mt-4 text-[#4CA7B1]'>
                            Jam
                          </label>
                          {/* <select
                            defaultValue={time}
                            onChange={(e) => {
                              setTime(e.target.value);
                            }}
                            className='p-2 border border-gray-400 rounded-md bg-[#D9D9D9] border-0'
                            required>
                            <option value=''>Pilih Jam</option>
                            {day !== "Sabtu" && age >= 7 && age <= 15 && (
                              <option value='16.00 WIB'>16.00 WIB</option>
                            )}
                            {day === "Sabtu" && age >= 7 && age <= 15 && (
                              <>
                                <option value='09.00 WIB'>09.00 WIB</option>
                                <option value='13.00 WIB'>13.00 WIB</option>
                              </>
                            )}
                          </select> */}
                          <input
                            name='time'
                            type='text'
                            placeholder='Contoh: 10:00'
                            className='w-full bg-[#D9D9D9] outline-none p-2 rounded-[10px] border-0'
                            pattern='[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$'
                            required
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        {age !== "" && (
                          <div className='text-red-500 text-xs'>
                            * usia yang dapat mengikut trial class Robotic
                            berusia 7 - 15 tahun.
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </>
              ) : null}

              {active === "english" ? (
                <div className='flex flex-col'>
                  <label className='mb-2 text-[#4CA7B1]'>
                    Umur Anak (tahun)
                  </label>
                  <input
                    type='number'
                    min='3'
                    max='15'
                    defaultValue={age}
                    onChange={(e) => setAge(e.target.value)}
                    className='p-2 border border-gray-400 rounded-md bg-[#D9D9D9] border-0'
                    required
                  />
                  {age >= 3 && age <= 15 ? (
                    <>
                      <div className='flex flex-col '>
                        <label className='mb-2 mt-4 text-[#4CA7B1] '>
                          Hari
                        </label>
                        <select
                          defaultValue={day}
                          onChange={(e) => {
                            setDay(e.target.value);
                          }}
                          className='p-2 border border-gray-400 rounded-md bg-[#D9D9D9] border-0'
                          required>
                          <option value=''>Pilih Hari</option>
                          <option value='Senin'>Senin</option>
                          <option value='Selasa'>Selasa</option>
                          <option value='Rabu'>Rabu</option>
                          <option value='Kamis'>Kamis</option>
                          <option value='Jumat'>Jumat</option>
                          <option value='Sabtu'>Sabtu</option>
                          {/* <option value='Minggu'>Minggu</option> */}
                        </select>
                        <label className='mb-2 mt-4 text-[#4CA7B1]'>Jam</label>
                        {/* <select
                          defaultValue={time}
                          onChange={(e) => {
                            setTime(e.target.value);
                          }}
                          className='p-2 border border-gray-400 rounded-md bg-[#D9D9D9] border-0'
                          required>
                          <option value=''>Pilih Jam</option>
                          {day !== "Sabtu" && age >= 3 && age <= 8 && (
                            <option value='15.00 WIB'>15.00 WIB</option>
                          )}
                          {day === "Sabtu" && age >= 3 && age <= 8 && (
                            <option value='09.00 WIB'>09.00 WIB</option>
                          )}
                          {day !== "Sabtu" && age >= 9 && age <= 15 && (
                            <option value='16.00 WIB'>16.00 WIB</option>
                          )}
                          {day === "Sabtu" && age >= 9 && age <= 15 && (
                            <option value='11.00 WIB'>11.00 WIB</option>
                          )}
                        </select> */}
                        <input
                          name='time'
                          type='text'
                          placeholder='Contoh: 10:00'
                          className='w-full bg-[#D9D9D9] outline-none p-2 rounded-[10px] border-0'
                          pattern='[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$'
                          required
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      {age !== "" && (
                        <div className='text-red-500 text-xs'>
                          * usia yang dapat mengikut trial class English berusia
                          3 - 15 tahun.
                        </div>
                      )}
                    </>
                  )}
                </div>
              ) : null}

              {active === "korean" ? (
                <div className='flex flex-col'>
                  <label className='mb-2 text-[#4CA7B1]'>
                    Umur Anak (tahun)
                  </label>
                  <input
                    type='number'
                    min='3'
                    max='15'
                    defaultValue={age}
                    onChange={(e) => setAge(e.target.value)}
                    className='p-2 border border-gray-400 rounded-md bg-[#D9D9D9] border-0'
                    required
                  />
                  {age >= 3 && age <= 15 ? (
                    <>
                      <div className='flex flex-col '>
                        <label className='mb-2 mt-4 text-[#4CA7B1] '>
                          Hari
                        </label>
                        <select
                          defaultValue={day}
                          onChange={(e) => {
                            setDay(e.target.value);
                          }}
                          className='p-2 border border-gray-400 rounded-md bg-[#D9D9D9] border-0'
                          required>
                          <option value=''>Pilih Hari</option>
                          <option value='Senin'>Senin</option>
                          <option value='Selasa'>Selasa</option>
                          <option value='Rabu'>Rabu</option>
                          <option value='Kamis'>Kamis</option>
                          <option value='Jumat'>Jumat</option>
                          <option value='Sabtu'>Sabtu</option>
                          {/* <option value='Minggu'>Minggu</option> */}
                        </select>
                        <label className='mb-2 mt-4 text-[#4CA7B1]'>Jam</label>
                        {/* <select
                          defaultValue={time}
                          onChange={(e) => {
                            setTime(e.target.value);
                          }}
                          className='p-2 border border-gray-400 rounded-md bg-[#D9D9D9] border-0'
                          required>
                          <option value=''>Pilih Jam</option>
                          {age >= 3 && age <= 8 && (
                            <option value='14.00 WIB'>14.00 WIB</option>
                          )}
                          {age >= 9 && age <= 15 && (
                            <option value='15.00 WIB'>15.00 WIB</option>
                          )}
                        </select> */}
                        <input
                          name='time'
                          type='text'
                          placeholder='Contoh: 10:00'
                          className='w-full bg-[#D9D9D9] outline-none p-2 rounded-[10px] border-0'
                          pattern='[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$'
                          required
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      {age !== "" && (
                        <div className='text-red-500 text-xs'>
                          * usia yang dapat mengikut trial class Korean berusia
                          3 - 15 tahun.
                        </div>
                      )}
                    </>
                  )}
                </div>
              ) : null}

              {active === "japan" ? (
                <div className='flex flex-col'>
                  <label className='mb-2  text-[#4CA7B1]'>
                    Umur Anak (tahun)
                  </label>
                  <input
                    type='number'
                    min='3'
                    max='40'
                    defaultValue={age}
                    onChange={(e) => setAge(e.target.value)}
                    className='p-2 border border-gray-400 rounded-md bg-[#D9D9D9] border-0'
                    required
                  />
                  {age >= 3 && age <= 40 ? (
                    <>
                      <div className='flex flex-col '>
                        <label className='mb-2 mt-4 text-[#4CA7B1] '>
                          Hari
                        </label>
                        <select
                          defaultValue={day}
                          onChange={(e) => {
                            setDay(e.target.value);
                          }}
                          className='p-2 border border-gray-400 rounded-md bg-[#D9D9D9] border-0'
                          required>
                          <option value=''>Pilih Hari</option>
                          <option value='Senin'>Senin</option>
                          <option value='Selasa'>Selasa</option>
                          <option value='Rabu'>Rabu</option>
                          <option value='Kamis'>Kamis</option>
                          <option value='Jumat'>Jumat</option>
                          <option value='Sabtu'>Sabtu</option>
                          {/* <option value='Minggu'>Minggu</option> */}
                        </select>
                        <label className='mb-2 mt-4 text-[#4CA7B1]'>Jam</label>
                        {/* <select
                          defaultValue={time}
                          onChange={(e) => {
                            setTime(e.target.value);
                          }}
                          className='p-2 border border-gray-400 rounded-md bg-[#D9D9D9] border-0'
                          required>
                          <option value=''>Pilih Jam</option>
                          {age >= 3 && age <= 40 && (
                            <option value='16.00 WIB'>16.00 WIB</option>
                          )}
                        </select> */}
                        <input
                          name='time'
                          type='text'
                          placeholder='Contoh: 10:00'
                          className='w-full bg-[#D9D9D9] outline-none p-2 rounded-[10px] border-0'
                          pattern='[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$'
                          required
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      {age !== "" && (
                        <div className='text-red-500 text-xs'>
                          * usia yang dapat mengikut trial class Japan berusia 3
                          - 40 tahun.
                        </div>
                      )}
                    </>
                  )}
                </div>
              ) : null}
              {active === "arab" ? (
                <div className='flex flex-col'>
                  <label className='mb-2 text-[#4CA7B1]'>
                    Umur Anak (tahun)
                  </label>
                  <input
                    type='number'
                    min='3'
                    max='15'
                    defaultValue={age}
                    onChange={(e) => setAge(e.target.value)}
                    className='p-2 border border-gray-400 rounded-md bg-[#D9D9D9] border-0'
                    required
                  />
                  {age >= 3 && age <= 15 ? (
                    <>
                      <div className='flex flex-col '>
                        <label className='mb-2 mt-4 text-[#4CA7B1] '>
                          Hari
                        </label>
                        <select
                          defaultValue={day}
                          onChange={(e) => {
                            setDay(e.target.value);
                          }}
                          className='p-2 border border-gray-400 rounded-md bg-[#D9D9D9] border-0'
                          required>
                          <option value=''>Pilih Hari</option>
                          <option value='Senin'>Senin</option>
                          <option value='Selasa'>Selasa</option>
                          <option value='Rabu'>Rabu</option>
                          <option value='Kamis'>Kamis</option>
                          <option value='Jumat'>Jumat</option>
                          <option value='Sabtu'>Sabtu</option>
                          {/* <option value='Minggu'>Minggu</option> */}
                        </select>
                        <label className='mb-2 mt-4 text-[#4CA7B1]'>Jam</label>
                        {/* <select
                          defaultValue={time}
                          onChange={(e) => {
                            setTime(e.target.value);
                          }}
                          className='p-2 border border-gray-400 rounded-md bg-[#D9D9D9] border-0'
                          required>
                          <option value=''>Pilih Jam</option>
                          {age >= 3 && age <= 8 && (
                            <option value='15.00 WIB'>15.00 WIB</option>
                          )}
                          {age >= 9 && age <= 15 && (
                            <option value='16.00 WIB'>16.00 WIB</option>
                          )}
                        </select> */}
                        <input
                          name='time'
                          type='text'
                          placeholder='Contoh: 10:00'
                          className='w-full bg-[#D9D9D9] outline-none p-2 rounded-[10px] border-0'
                          pattern='[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$'
                          required
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      {age !== "" && (
                        <div className='text-red-500 text-xs'>
                          * usia yang dapat mengikut trial class Arab berusia 3
                          - 15 tahun.
                        </div>
                      )}
                    </>
                  )}
                </div>
              ) : null}

              {active === "coding" ? (
                <div className='flex flex-col'>
                  <label className='mb-2 text-[#4CA7B1]'>Tipe Kelas</label>
                  <div className='grid grid-cols-3 gap-1'>
                    <div
                      onClick={() => {
                        setActive2("scratch");
                        setAge(null);
                      }}
                      className={` rounded-[10px] border-2 border-solid border-turquoise-normal p-4 flex flex-col justify-center items-center cursor-pointer 
                  ${active2 === "scratch" ? "bg-[#F7CE46]" : "bg-white"}`}>
                      <input
                        type='radio'
                        id='scratch'
                        // name="tipekelas"
                        // value="Scratch"
                        className=' opacity-0 absolute '
                        defaultChecked={active2 === "scratch" ? true : false}
                        required
                        onChange={(e) => {
                          console.log(e);
                          if (e.target.checked) {
                            setClass1("Coding Scratch");
                          } else {
                            setClass1("");
                          }
                        }}
                      />
                      <label htmlFor='scratch'>Scratch</label>
                    </div>
                    <div
                      onClick={() => {
                        setActive2("tynker");
                        setAge(null);
                      }}
                      className={` rounded-[10px] border-2 border-solid border-turquoise-normal p-4 flex flex-col justify-center items-center cursor-pointer 
                   ${active2 === "tynker" ? "bg-[#F7CE46]" : "bg-white"}`}>
                      <input
                        type='radio'
                        id='tynker'
                        // name="tipekelas"
                        // value="Tynker"
                        className=' opacity-0  absolute'
                        defaultChecked={active2 === "tynker" ? true : false}
                        required
                        onChange={(e) => {
                          console.log(e);
                          if (e.target.checked) {
                            setClass1("Coding Tynker");
                          } else {
                            setClass1("");
                          }
                        }}
                      />
                      <label htmlFor='tynker'>Tynker</label>
                    </div>
                    <div
                      onClick={() => {
                        setActive2("roblox");
                        setAge(null);
                      }}
                      className={` rounded-[10px] border-2 border-solid border-turquoise-normal p-4 flex flex-col justify-center items-center cursor-pointer 
                  ${active2 === "roblox" ? "bg-[#F7CE46]" : "bg-white"}`}>
                      <input
                        type='radio'
                        id='roblox'
                        // name="tipekelas"
                        // value="Roblox"
                        className=' opacity-0 absolute'
                        defaultChecked={active2 === "roblox" ? true : false}
                        required
                        onChange={(e) => {
                          console.log(e);
                          if (e.target.checked) {
                            setClass1("Coding Roblox");
                          } else {
                            setClass1("");
                          }
                        }}
                      />
                      <label htmlFor='roblox'>Roblox</label>
                    </div>
                  </div>
                </div>
              ) : null}

              {active === "coding" && active2 === "scratch" && (
                <div className='flex flex-col'>
                  <label className='mb-2 text-[#4CA7B1]'>Kelas</label>
                  <div className='grid grid-cols-2 gap-1'>
                    {/* <div
                      onClick={() => {
                        setActive2("scratch");
                        setActiveCoding("online");
                        setAge(null);
                      }}
                      className={` rounded-[10px] border-2 border-solid border-turquoise-normal p-4 flex flex-col justify-center items-center cursor-pointer 
              ${
                active2 === "scratch" && activeCoding === "online"
                  ? "bg-[#F7CE46]"
                  : "bg-white"
              }`}>
                      <input
                        type='radio'
                        id='online'
                        className=' opacity-0 absolute '
                        defaultChecked={
                          active2 === "scratch"
                            ? true
                            : false && activeCoding === "online"
                            ? true
                            : false
                        }
                        required
                        onChange={(e) => {
                          console.log(e);
                          if (e.target.checked) {
                            setClass1("Coding Scratch");
                            setActiveCoding("Online");
                          } else {
                            setClass1("");
                          }
                        }}
                      />
                      <label htmlFor='online'>Online</label>
                    </div> */}
                    <div
                      onClick={() => {
                        setActive2("scratch");
                        setActiveCoding("offline");
                        setAge(null);
                      }}
                      className={` rounded-[10px] border-2 border-solid border-turquoise-normal p-4 flex flex-col justify-center items-center cursor-pointer 
               ${
                 active2 === "scratch" && activeCoding === "offline"
                   ? "bg-[#F7CE46]"
                   : "bg-white"
               }`}>
                      <input
                        type='radio'
                        id='offline'
                        className=' opacity-0  absolute'
                        defaultChecked={
                          active2 === "scratch"
                            ? true
                            : false && activeCoding === "offline"
                            ? true
                            : false
                        }
                        required
                        onChange={(e) => {
                          console.log(e);
                          if (e.target.checked) {
                            setClass1("Coding Scratch");
                            setActiveCoding("offline");
                          } else {
                            setClass1("");
                          }
                        }}
                      />
                      <label htmlFor='offline'>Offline</label>
                    </div>
                  </div>
                </div>
              )}
              {active === "coding" && active2 === "tynker" && (
                <div className='flex flex-col'>
                  <label className='mb-2 text-[#4CA7B1]'>Kelas</label>
                  <div className='grid grid-cols-2 gap-1'>
                    <div
                      onClick={() => {
                        setActive2("tynker");
                        setActiveCoding("offline");
                        setAge(null);
                      }}
                      className={` rounded-[10px] border-2 border-solid border-turquoise-normal p-4 flex flex-col justify-center items-center cursor-pointer 
               ${
                 active2 === "tynker" && activeCoding === "offline"
                   ? "bg-[#F7CE46]"
                   : "bg-white"
               }`}>
                      <input
                        type='radio'
                        id='offline'
                        className=' opacity-0  absolute'
                        defaultChecked={
                          active2 === "tynker"
                            ? true
                            : false && activeCoding === "offline"
                            ? true
                            : false
                        }
                        required
                        onChange={(e) => {
                          console.log(e);
                          if (e.target.checked) {
                            setClass1("Coding Tynker");
                            setActiveCoding("offline");
                          } else {
                            setClass1("");
                          }
                        }}
                      />
                      <label htmlFor='offline'>Offline</label>
                    </div>
                  </div>
                </div>
              )}
              {active === "coding" && active2 === "roblox" && (
                <div className='flex flex-col'>
                  <label className='mb-2 text-[#4CA7B1]'>Kelas</label>
                  <div className='grid grid-cols-2 gap-1'>
                    <div
                      onClick={() => {
                        setActive2("roblox");
                        setActiveCoding("offline");
                        setAge(null);
                      }}
                      className={` rounded-[10px] border-2 border-solid border-turquoise-normal p-4 flex flex-col justify-center items-center cursor-pointer 
               ${
                 active2 === "roblox" && activeCoding === "offline"
                   ? "bg-[#F7CE46]"
                   : "bg-white"
               }`}>
                      <input
                        type='radio'
                        id='offline'
                        className=' opacity-0  absolute'
                        defaultChecked={
                          active2 === "roblox"
                            ? true
                            : false && activeCoding === "offline"
                            ? true
                            : false
                        }
                        required
                        onChange={(e) => {
                          console.log(e);
                          if (e.target.checked) {
                            setClass1("Coding roblox");
                            setActiveCoding("offline");
                          } else {
                            setClass1("");
                          }
                        }}
                      />
                      <label htmlFor='offline'>Offline</label>
                    </div>
                  </div>
                </div>
              )}

              {active === "coding" &&
              active2 === "scratch" &&
              activeCoding === "online" ? (
                <div className='flex flex-col'>
                  <label className='mb-2 text-[#4CA7B1]'>
                    Umur Anak (tahun)
                  </label>
                  <input
                    type='number'
                    min='3'
                    max='15'
                    defaultValue={age}
                    onChange={(e) => setAge(e.target.value)}
                    className='p-2 border border-gray-400 rounded-md bg-[#D9D9D9] border-0'
                    required
                  />
                  {age >= 3 && age <= 15 ? (
                    <>
                      <div className='flex flex-col '>
                        <label className='mb-2 mt-4 text-[#4CA7B1] '>
                          Hari
                        </label>
                        <select
                          defaultValue={day}
                          onChange={(e) => {
                            setDay(e.target.value);
                          }}
                          className='p-2 border border-gray-400 rounded-md bg-[#D9D9D9] border-0'
                          required>
                          <option value=''>Pilih Hari</option>
                          <option value='Senin'>Senin</option>
                          <option value='Selasa'>Selasa</option>
                          <option value='Rabu'>Rabu</option>
                          <option value='Kamis'>Kamis</option>
                          <option value='Jumat'>Jumat</option>
                          <option value='Sabtu'>Sabtu</option>
                          {/* <option value='Minggu'>Minggu</option> */}
                        </select>
                        <label className='mb-2 mt-4 text-[#4CA7B1]'>Jam</label>
                        {/* <select
                          defaultValue={time}
                          onChange={(e) => {
                            setTime(e.target.value);
                          }}
                          className='p-2 border border-gray-400 rounded-md bg-[#D9D9D9] border-0'
                          required>
                          <option value=''>Pilih Jam</option>
                          {day !== "Sabtu" && age >= 3 && age <= 8 && (
                            <option value='15.00 WIB'>15.00 WIB</option>
                          )}
                          {day === "Sabtu" && age >= 3 && age <= 8 && (
                            <option value='10.00 WIB'>10.00 WIB</option>
                          )}
                          {day !== "Sabtu" && age >= 9 && age <= 15 && (
                            <option value='16.00 WIB'>16.00 WIB</option>
                          )}
                          {day === "Sabtu" && age >= 9 && age <= 815 && (
                            <option value='11.00 WIB'>11.00 WIB</option>
                          )}
                        </select> */}
                        <input
                          name='time'
                          type='text'
                          placeholder='Contoh: 10:00'
                          className='w-full bg-[#D9D9D9] outline-none p-2 rounded-[10px] border-0'
                          pattern='[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$'
                          required
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      {age !== "" && (
                        <div className='text-red-500 text-xs'>
                          * usia yang dapat mengikut trial class Scratch berusia
                          3 - 15 tahun.
                        </div>
                      )}
                    </>
                  )}
                </div>
              ) : null}

              {active === "coding" &&
              active2 === "scratch" &&
              activeCoding === "offline" ? (
                <div className='flex flex-col'>
                  <label className='mb-2 text-[#4CA7B1]'>
                    Umur Anak (tahun)
                  </label>
                  <input
                    type='number'
                    min='3'
                    max='15'
                    defaultValue={age}
                    onChange={(e) => setAge(e.target.value)}
                    className='p-2 border border-gray-400 rounded-md bg-[#D9D9D9] border-0'
                    required
                  />
                  {age >= 3 && age <= 15 ? (
                    <>
                      <div className='flex flex-col '>
                        <label className='mb-2 mt-4 text-[#4CA7B1] '>
                          Hari
                        </label>
                        <select
                          defaultValue={day}
                          onChange={(e) => {
                            setDay(e.target.value);
                          }}
                          className='p-2 border border-gray-400 rounded-md bg-[#D9D9D9] border-0'
                          required>
                          <option value=''>Pilih Hari</option>
                          <option value='Senin'>Senin</option>
                          <option value='Selasa'>Selasa</option>
                          <option value='Rabu'>Rabu</option>
                          <option value='Kamis'>Kamis</option>
                          <option value='Jumat'>Jumat</option>
                          <option value='Sabtu'>Sabtu</option>
                          {/* <option value='Minggu'>Minggu</option> */}
                        </select>
                        <label className='mb-2 mt-4 text-[#4CA7B1]'>Jam</label>
                        {/* <select
                          defaultValue={time}
                          onChange={(e) => {
                            setTime(e.target.value);
                          }}
                          className='p-2 border border-gray-400 rounded-md bg-[#D9D9D9] border-0'
                          required>
                          <option value=''>Pilih Jam</option>
                          {day !== "Sabtu" && age >= 3 && age <= 8 && (
                            <option value='15.00 WIB'>15.00 WIB</option>
                          )}
                          {day === "Sabtu" && age >= 3 && age <= 8 && (
                            <option value='10.00 WIB'>10.00 WIB</option>
                          )}
                          {day !== "Sabtu" && age >= 9 && age <= 15 && (
                            <option value='16.00 WIB'>16.00 WIB</option>
                          )}
                          {day === "Sabtu" && age >= 9 && age <= 815 && (
                            <option value='11.00 WIB'>11.00 WIB</option>
                          )}
                        </select> */}
                        <input
                          name='time'
                          type='text'
                          placeholder='Contoh: 10:00'
                          className='w-full bg-[#D9D9D9] outline-none p-2 rounded-[10px] border-0'
                          pattern='[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$'
                          required
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      {age !== "" && (
                        <div className='text-red-500 text-xs'>
                          * usia yang dapat mengikut trial class Scratch berusia
                          3 - 15 tahun.
                        </div>
                      )}
                    </>
                  )}
                </div>
              ) : null}

              {active === "coding" && active2 === "tynker" ? (
                <div className='flex flex-col'>
                  <label className='mb-2 text-[#4CA7B1]'>
                    Umur Anak (tahun)
                  </label>
                  <input
                    type='number'
                    min='3'
                    max='15'
                    defaultValue={age}
                    onChange={(e) => setAge(e.target.value)}
                    className='p-2 border border-gray-400 rounded-md bg-[#D9D9D9] border-0'
                    required
                  />
                  {age >= 3 && age <= 15 ? (
                    <>
                      <div className='flex flex-col '>
                        <label className='mb-2 mt-4 text-[#4CA7B1] '>
                          Hari
                        </label>
                        <select
                          defaultValue={day}
                          onChange={(e) => {
                            setDay(e.target.value);
                          }}
                          className='p-2 border border-gray-400 rounded-md bg-[#D9D9D9] border-0'
                          required>
                          <option value=''>Pilih Hari</option>
                          <option value='Senin'>Senin</option>
                          <option value='Selasa'>Selasa</option>
                          <option value='Rabu'>Rabu</option>
                          <option value='Kamis'>Kamis</option>
                          <option value='Jumat'>Jumat</option>
                          <option value='Sabtu'>Sabtu</option>
                          {/* <option value='Minggu'>Minggu</option> */}
                        </select>
                        <label className='mb-2 mt-4 text-[#4CA7B1]'>Jam</label>
                        <input
                          name='time'
                          type='text'
                          placeholder='Contoh: 10:00'
                          className='w-full bg-[#D9D9D9] outline-none p-2 rounded-[10px] border-0'
                          pattern='[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$'
                          required
                        />
                        {/* <select
                          defaultValue={time}
                          onChange={(e) => {
                            setTime(e.target.value);
                          }}
                          className='p-2 border border-gray-400 rounded-md bg-[#D9D9D9] border-0'
                          required>
                          <option value=''>Pilih Jam</option>
                          {day !== "Sabtu" && age >= 3 && age <= 15 && (
                            <option value='16.00 WIB'>16.00 WIB</option>
                          )}
                          {day === "Sabtu" && age >= 3 && age <= 15 && (
                            <option value='11.00 WIB'>11.00 WIB</option>
                          )}
                        </select> */}
                      </div>
                    </>
                  ) : (
                    <>
                      {age !== "" && (
                        <div className='text-red-500 text-xs'>
                          * usia yang dapat mengikut trial class Tynker berusia
                          3 - 15 tahun.
                        </div>
                      )}
                    </>
                  )}
                </div>
              ) : null}

              {active === "coding" && active2 === "roblox" ? (
                <div className='flex flex-col'>
                  <label className='mb-2 text-[#4CA7B1]'>
                    Umur Anak (tahun)
                  </label>
                  <input
                    type='number'
                    min='3'
                    max='15'
                    defaultValue={age}
                    onChange={(e) => setAge(e.target.value)}
                    className='p-2 border border-gray-400 rounded-md bg-[#D9D9D9] border-0'
                    required
                  />
                  {age >= 3 && age <= 15 ? (
                    <>
                      <div className='flex flex-col '>
                        <label className='mb-2 mt-4 text-[#4CA7B1]'>Hari</label>
                        <select
                          defaultValue={day}
                          onChange={(e) => {
                            setDay(e.target.value);
                          }}
                          className='p-2 border border-gray-400 rounded-md bg-[#D9D9D9] border-0'
                          required>
                          <option value=''>Pilih Hari</option>
                          <option value='Senin'>Senin</option>
                          <option value='Selasa'>Selasa</option>
                          <option value='Rabu'>Rabu</option>
                          <option value='Kamis'>Kamis</option>
                          <option value='Jumat'>Jumat</option>
                          <option value='Sabtu'>Sabtu</option>
                          {/* <option value='Minggu'>Minggu</option> */}
                        </select>
                        <label className='mb-2 mt-4 text-[#4CA7B1]'>Jam</label>
                        {/* <select
                          defaultValue={time}
                          onChange={(e) => {
                            setTime(e.target.value);
                          }}
                          className='p-2 border border-gray-400 rounded-md bg-[#D9D9D9] border-0'
                          required>
                          <option value=''>Pilih Jam</option>
                          {day !== "Sabtu" && age >= 3 && age <= 15 && (
                            <option value='16.00 WIB'>16.00 WIB</option>
                          )}
                          {day === "Sabtu" && age >= 3 && age <= 15 && (
                            <option value='16.00 WIB'>16.00 WIB</option>
                          )}
                        </select> */}
                        <input
                          name='time'
                          type='text'
                          placeholder='Contoh: 10:00'
                          className='w-full bg-[#D9D9D9] outline-none p-2 rounded-[10px] border-0'
                          pattern='[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$'
                          required
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      {age !== "" && (
                        <div className='text-red-500 text-xs'>
                          * usia yang dapat mengikut trial class Roblox berusia
                          3 - 15 tahun.
                        </div>
                      )}
                    </>
                  )}
                </div>
              ) : null}

              <div className='flex flex-col'>
                <label className='mb-2 text-[#4CA7B1]'>Email</label>
                <input
                  name='email'
                  type='email'
                  className='w-full bg-[#D9D9D9] outline-none p-2 rounded-[10px] border-0'
                  pattern='[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$'
                  required
                />
              </div>
              <div className='flex flex-col'>
                <label className='mb-2 text-[#4CA7B1]'>
                  Nama Lengkap Orang Tua
                </label>
                <input
                  name='parent'
                  type='text'
                  className='w-full bg-[#D9D9D9] outline-none p-2 rounded-[10px] border-0'
                  required
                />
              </div>
              <div className='flex flex-col'>
                <label className='mb-2 text-[#4CA7B1]'>Nama Lengkap Anak</label>
                <input
                  name='child'
                  type='text'
                  className='w-full bg-[#D9D9D9] outline-none p-2 rounded-[10px] border-0'
                  required
                />
              </div>
              <div className='flex flex-col'>
                <label className='mb-2 text-[#4CA7B1]'>No. WhatsApp</label>
                <input
                  defaultValue={"62"}
                  name='wa'
                  type='text'
                  className='w-full bg-[#D9D9D9] outline-none p-2 rounded-[10px] border-0'
                  pattern='^[0-9]*$'
                  required
                />
              </div>

              {/* <button
                type="submit"
                className="bg-[#F7CE46] mt-4 w-full h-10 text-white rounded-[10px] hover:bg-[#4CA7B1]"
              >
                Submit Registration
              </button> */}
              <button
                type='submit'
                className='bg-[#F7CE46] mt-4 w-full h-10 text-white rounded-[10px] hover:bg-[#4CA7B1]'
                disabled={isLoading} // Menonaktifkan tombol saat loading
              >
                {isLoading ? "Loading..." : "Submit Registration"}
              </button>
            </form>
          </div>
          <Transition appear show={isOpen} as={Fragment}>
            <Dialog as='div' className='relative z-10' onClose={closeModal}>
              <Transition.Child
                as={Fragment}
                enter='ease-out duration-300'
                enterFrom='opacity-0'
                enterTo='opacity-100'
                leave='ease-in duration-200'
                leaveFrom='opacity-100'
                leaveTo='opacity-0'>
                <div className='fixed inset-0 bg-black bg-opacity-25' />
              </Transition.Child>

              <div className='fixed inset-0 overflow-y-auto'>
                <div className='flex min-h-full items-center justify-center p-4 text-center'>
                  <Transition.Child
                    as={Fragment}
                    enter='ease-out duration-300'
                    enterFrom='opacity-0 scale-95'
                    enterTo='opacity-100 scale-100'
                    leave='ease-in duration-200'
                    leaveFrom='opacity-100 scale-100'
                    leaveTo='opacity-0 scale-95'>
                    <Dialog.Panel className='w-full max-w-md transform overflow-hidden rounded-2xl bg-gray-100 p-6 text-left align-middle shadow-xl transition-all'>
                      <Dialog.Title
                        as='h3'
                        className='text-lg font-medium leading-6 text-gray-900'>
                        Pendaftaran Trial
                      </Dialog.Title>
                      <div className='mt-2'>
                        <div className='text-sm text-gray-500'>
                          {isError != null && isError ? (
                            errorMessage
                          ) : (
                            <div>
                              <p>{successMessage}</p>
                              <div>
                                Jika ada pertanyaan, silahkan menghubungi Miss
                                Ayu{" "}
                                <a
                                  className='text-turquoise-normal'
                                  href='http://wa.me/6287790269926'
                                  target='_blank '
                                  rel=''>
                                  +6287790269926
                                </a>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className='mt-4'>
                        <button
                          type='button'
                          className='inline-flex justify-center rounded-full border border-transparent bg-[#F7CE46] hover:bg-[#4CA7B1] px-4 py-2 text-sm font-medium text-white focus:outline-none '
                          onClick={() => {
                            closeModal();
                            if (!isError) {
                              window.location.reload();
                            }
                          }}>
                          {isError != null && isError
                            ? "Silahkan perbaiki"
                            : "Baik, terimakasih!"}
                        </button>
                      </div>
                    </Dialog.Panel>
                  </Transition.Child>
                </div>
              </div>
            </Dialog>
          </Transition>
        </div>
      </section>

      {/* ABOUT US */}
      <section className='flex flex-col  px-4 lg:px-24  gap-12 items-center justify-center lg:pt-20 lg:pb-20 pt-12 bg-gray-100'>
        <div className='flex flex-col lg:flex-row   gap-4 mb-12 lg:mb-0 w-full lg:max-w-7xl mx-auto'>
          <div className='text-[14px] lg:text-[18px] text-[#717171] font-[400] text-left lg:text-left w-full lg:w-1/2'>
            <h1 className='md:text-2xl text-2xl font-bold text-[#4CA7B1] font-sans mb-5'>
              Know about Educourse learning platform
            </h1>
            <span className='font-bold text-[#4CA7B1]'>Educourse.id</span> is a
            STEM-based education platform that prepares future skills based on
            4.0 needs. We design and implement STEM-based curricula in courses
            enhanced with AR, AI, and IoT technology experiences.
            <div className='flex flex-col gap-4'>
              <div className='flex items-center gap-2'>
                <FaCheckSquare className='text-gray-500' size={24} />
                <div>
                  <span className='text-gray-700'>
                    Easy &amp; Unique Methods
                  </span>
                  <p className='text-sm text-gray-500'>
                    Using the world&apos;s best curriculum STEAM based methods
                  </p>
                </div>
              </div>
              <div className='flex items-center gap-2'>
                <FaCheckSquare className='text-gray-500' size={24} />
                <div>
                  <span className='text-gray-700'>Advanced Technology</span>
                  <p className='text-sm text-gray-500'>
                    Using blended learning and supported by AR and AI Technology
                  </p>
                </div>
              </div>
              <div className='flex items-center gap-2'>
                <FaCheckSquare className='text-gray-500' size={24} />
                <div>
                  <span className='text-gray-700'>Affordable Price</span>
                  <p className='text-sm text-gray-500'>
                    Using price transparency based on consumer needs
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className='flex flex-col gap-4 mb-12 lg:mb-0 w-full lg:w-1/2'>
            <div className='bg-white rounded-lg overflow-hidden shadow-md w-full h-80 lg:h-full'>
              <iframe
                className='w-full h-full'
                src='https://www.youtube.com/embed/v0KgsqkwoJo'
                title='Video 1'
                allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                allowFullScreen></iframe>
            </div>
          </div>
        </div>
      </section>

      <div className='flex flex-col justify-center min-h-screen bg-gray-100'>
        <div className='md:text-2xl text-2xl font-bold text-[#4CA7B1] font-sans text-center mb-10'>
          Join Us Through Free Trial Class
        </div>
        <div className='grid grid-cols-1 gap-8 md:grid-cols-3 md:mx-4'>
          <div className='bg-white rounded-lg overflow-hidden shadow-md'>
            <iframe
              className='w-full h-64 sm:h-72 md:h-80'
              src='https://www.youtube.com/embed/v0KgsqkwoJo'
              title='Video 1'
              allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
              allowFullScreen></iframe>
          </div>
          <div className='bg-white rounded-lg overflow-hidden shadow-md'>
            <iframe
              className='w-full h-64 sm:h-72 md:h-80'
              src='https://www.youtube.com/embed/NqPaXgThyO4'
              title='Video 2'
              allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
              allowFullScreen></iframe>
          </div>
          <div className='bg-white rounded-lg overflow-hidden shadow-md'>
            <iframe
              className='w-full h-64 sm:h-72 md:h-80'
              src='https://www.youtube.com/embed/2wxSqVGt1JQ'
              title='Video 3'
              allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
              allowFullScreen></iframe>
          </div>
        </div>
      </div>
    </>
  );
};

export default Index;
